import {Button} from '@freckle/educator-materials/ts/components/button'
import {Modal, Header, Body, Footer} from '@freckle/educator-materials/ts/components/modal'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'

type Props = {
  show: boolean
  onModalHide: () => void
  name: string
  email: string
  impersonateTeacher: () => void
}

export function ImpersonateModal(props: Props) {
  const {show, onModalHide, name, email, impersonateTeacher} = props
  const {t} = useSafeTranslation()

  return (
    <Modal show={show} onHide={onModalHide} customStyle={{height: '18rem', width: '50rem'}}>
      <Header onClickClose={onModalHide}>
        {t('MANAGE_TEACHERS_IMPERSONATE_MODAL_VIEW_DASHBOARD_OF_TITLE', {name})}
      </Header>
      <Body>
        <div className="row" data-test="impersonate-teacher-modal-body">
          <div className="col-12">
            <SafeTrans
              i18nKey="MANAGE_TEACHERS_IMPERSONATE_MODAL_VIEW_DASHBOARD_OF_BODY"
              values={{name, email}}
            />
          </div>
        </div>
      </Body>
      <Footer>
        <Button onClick={onModalHide} style="secondary">
          {t('MANAGE_TEACHERS_IMPERSONATE_MODAL_CANCEL')}
        </Button>
        <Button
          onClick={impersonateTeacher}
          style="primary"
          dataTest="impersonate-teacher-modal-ok-btn"
        >
          {t('MANAGE_TEACHERS_IMPERSONATE_MODAL_OK')}
        </Button>
      </Footer>
    </Modal>
  )
}
